import { coreService } from 'Src/network/AutomatedService';
import { definitions } from 'Src/vendor/posapi/pos';

type StandardDiscountWithSchedules = definitions['types.StandardDiscountWithSchedules'];
type DiscountReason = definitions['types.DiscountReason'];
type PromoCode = definitions['types.PromoCode'];
type DiscountType = definitions['types.DiscountType'];
type DiscountApplication = definitions['types.DiscountApplication'];

const service = {
  getAll: coreService['POS:GET:StandardDiscounts'],
};

export default service;
export type { DiscountApplication, DiscountReason, DiscountType, PromoCode, StandardDiscountWithSchedules };
